import { render, staticRenderFns } from "./ShippingOrders.vue?vue&type=template&id=07c87890&"
import script from "./ShippingOrders.vue?vue&type=script&lang=js&"
export * from "./ShippingOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports